import { render, staticRenderFns } from "./emba.vue?vue&type=template&id=21566bc5"
import script from "./emba.vue?vue&type=script&lang=ts"
export * from "./emba.vue?vue&type=script&lang=ts"
import style0 from "./emba.vue?vue&type=style&index=0&id=21566bc5&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports